<wr-base-dialog status="primary"
                header="Reparaturauftrag an Dienstleister senden"
                submitText="Senden"
                [disableSubmit]="form.invalid"
                [submitResponse]="submitResponse">
  <form class="mail-form" [formGroup]="form" data-cy="qr-repair-task-mail-form">
    <hau-form-field label="Betreff">
      <input nbInput fullWidth type="text" formControlName="subject" data-cy="qr-repair-task-mail-subject">
    </hau-form-field>
    <hau-form-field label="Empfänger (mehrere mit Komma trennen)">
      <input nbInput fullWidth type="text" formControlName="recipients" data-cy="qr-repair-task-mail-recipients">
    </hau-form-field>
    <hau-form-field label="Text">
      <wr-rich-text-editor formControlName="body"></wr-rich-text-editor>
    </hau-form-field>
    @if (attachmentCount > 0) {
      <p class="attachment-hint">{{ attachmentCount }} Foto(s) aus der Begehung werden angehängt.</p>
    }
  </form>
</wr-base-dialog>
